import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  Create,
  Edit,
  SimpleForm,
  TextInput,
  EditButton,
  DateField,
  SaveButton,
  Toolbar,
  TabbedForm,
  FormTab,
} from 'react-admin';

const required = (message = 'Required') =>
  value => value ? undefined : message;

const number = (message = 'More than 0') =>
  value => value && isNaN(Number(value)) && Number(value) > 0 ? message : undefined;

export const PornList = (props) => (
  <List {...props} title="List of Porns" bulkActionButtons={false}>
    <Datagrid>
      <DateField source="created_at" showTime/>
      <TextField source="name"/>
      <DateField source="updated_at" showTime/>
      <EditButton/>
    </Datagrid>
  </List>
);

export const PornCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="/porns">
      <TextInput source="name" validate={required()}/>
    </SimpleForm>
  </Create>
);

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton/>
  </Toolbar>
);

export const PornEdit = (props) => (
  <Edit {...props} undoable={false}>
    <TabbedForm redirect="/porns">
      <FormTab label="Porn Info">
        <TextInput source="name" validate={required()}/>
      </FormTab>
    </TabbedForm>
  </Edit>
);